import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchBindList } from '@/api/PMS/houseDeliveryManage/decorationRegistration';
import waves from '@/directive/waves'; // 水波纹指令

export default {
  directives: {
    waves: waves
  },
  props: ['showDialog', 'keyValue'],
  data: function data() {
    return {
      downloadLoading: false,
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: '',
      multipleSelection: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.listQuery = {
        page: 1,
        limit: 10
      };
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      var query = {
        houseId: this.keyValue
      };
      fetchBindList(query).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      val.forEach(function (item) {
        item.amount = item.fixedAmount;
        item.chargeMathName = item.chargeMath;
        item.chargeItemName = item.chargeName;
      });
      this.multipleSelection = val;
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'charge');
    },
    handleCreate: function handleCreate() {
      var _this2 = this;

      if (this.multipleSelection.length > 0) {
        this.$confirm('你确定是要添加这些收费标准, 是否继续?', '提示').then(function () {
          _this2.$emit('handSelect', _this2.multipleSelection);

          _this2.$emit('handCancle', 'charge');
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    }
  }
};